const EdgeDeviceSpecificationKeys = {
  DATA_COLLECTION_INTERVAL: "eh.user_config.data_collection_interval",
  DATA_SEND_INTERVAL: "eh.user_config.data_send_interval",
  DATA_SEND_START_TIME: "eh.user_config.data_send_start_time",
  DATA_SEND_ENVIRONMENT: "eh.user_config.data_send_environment",
  ETHERNET_IP_ACTIVE: "eh.user_config.ethernet_ip_active",
  PROFINET_ACTIVE: "eh.user_config.profinet_active",
};

export default EdgeDeviceSpecificationKeys;
